import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareBinary } from '@fortawesome/free-solid-svg-icons'
import { faCss3, faGitAlt, faHtml5, faJsSquare, faReact } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
            const timeoutId = setTimeout(() => {
                setLetterClass('text-animate-hover')
            }, 3000)
    
            return () => clearTimeout(timeoutId)
    
        }, [])

    return (
        <>
        <div className='container about-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
                        idx={15}
                    />
                </h1>
                <p>I recently graduated from the University of Delaware with a double major in applied mathematics and music (piano focus) and a minor in computer science. My curiosity drives me to solve complex problems, particularly in cryptography and number theory, where I’m exploring creative approaches through personal projects like a website for ciphers and cryptographic tools. I’m eager to start my career, build on these interests, and discover what I’m capable of professionally.</p>
                <p>Problem-solving has always been a cornerstone of my work and passions. Whether tackling technical challenges or mastering a new piece of music, I approach obstacles with persistence and adaptability. I rely on visualization to understand and break down complex ideas, often sketching out problems or data processes to see the bigger picture. This blend of analytical thinking and creativity helps me navigate challenges effectively.</p>
                <p>Outside of work, I find joy in pursuing creative and physical challenges. Music has been a lifelong passion, whether I’m learning songs by ear, arranging pieces, or performing with my band. It’s a way for me to channel creativity and connect with others. I also enjoy staying active, whether through running or playing ultimate frisbee, both of which help me maintain balance and focus. These pursuits fuel my curiosity and drive to keep learning and pushing my limits, both personally and professionally.</p>

            </div>
            <div className='stage-cube-cont'>
                <div className='cubespinner'>
                    <div className='face1'>
                        <FontAwesomeIcon icon={faReact} color='#5ED4F4' />
                    </div>
                    <div className='face2'>
                        <FontAwesomeIcon icon={faHtml5} color='#F06529' />
                    </div>
                    <div className='face3'>
                        <FontAwesomeIcon icon={faCss3} color='#28A4D9' />
                    </div>
                    <div className='face4'>
                        <FontAwesomeIcon icon={faJsSquare} color='#EFD81D' />
                    </div>
                    <div className='face5'>
                        <FontAwesomeIcon icon={faGitAlt} color='#EC4D28' />
                    </div>
                    <div className='face6'>
                        <FontAwesomeIcon icon={faSquareBinary} color='#FFFFFF' />
                    </div>
                </div>
            </div>
        </div>
        <Loader type='pacman' />
        </>
    )

}

export default About